var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPerson = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M12 13.95a3.85 3.85 0 0 1-2.07-.598 4.26 4.26 0 0 1-1.46-1.615q-.537-1.017-.55-2.297a4.4 4.4 0 0 1 .539-2.202A4.4 4.4 0 0 1 9.93 5.635a3.7 3.7 0 0 1 2.07-.61q1.137 0 2.058.61a4.4 4.4 0 0 1 1.471 1.603q.55 1.005.55 2.202 0 1.28-.538 2.309a4.23 4.23 0 0 1-1.471 1.615 3.77 3.77 0 0 1-2.07.586m8.124 5.839a11 11 0 0 1-2.477 1.854q-1.387.777-2.86 1.185-1.459.406-2.787.406-1.305 0-2.788-.418A13 13 0 0 1 6.33 21.63a10.4 10.4 0 0 1-2.453-1.842l.024-.12q.335-.85 1.436-1.699 1.113-.85 2.812-1.412T12 15.996t3.864.562 2.8 1.424q1.1.85 1.436 1.71z"
})));
export default SvgPerson;